module.exports = __webpack_public_path__ + "img/home-3-person-mobile.2e45b8c4.png";